module.exports = __webpack_public_path__ + "img/thumbnail-5.a859d2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-5.jpg
// module id = HfXz
// module chunks = 1